import axios from 'axios';
import {token} from '../services/Authentication'

class CompanyService {

  static async companies(term) {
    try {
      const res = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_URL_MEDIASIM}/empresa/todos?term=${term}`,
        headers: {
          "content-type": "application/json",
          "authorization": token(),
        },
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

}


export default CompanyService;